import { gsap, ScrollTrigger } from '../../global/gsap';

const initPeopleFilter = (peopleFilter) => {
    const filterRolesToggle = peopleFilter.querySelector('.js-roles-toggle');
    const filterRoles = peopleFilter.querySelector('.js-filter-roles');
    const filterBtns = filterRoles.querySelectorAll('.js-filter-btn');
    const peopleGrid = document.querySelector('.js-people-grid');
    const searchTermText = document.querySelector('.js-search-term');
    const peopleCards = gsap.utils.toArray('.js-people-card');
    let selectedFilter = '';
    let foundCards = [];
    const searchInput = peopleFilter.querySelector('.js-people-search');
    let searchCards;

    function toggle(btn, tl) {
        // eslint-disable-next-line no-unused-expressions
        tl.reversed() ? tl.play() : tl.reverse();
        btn.classList.toggle('active');
    }

    const media = gsap.matchMedia();
    const breakpoint = 900;

    media.add(
        {
            isDesktop: `(min-width: ${breakpoint}px)`,
            isMobile: `(max-width: ${breakpoint - 1}px)`,
        },
        (context) => {
            const { isMobile } = context.conditions;

            if (isMobile) {
                const tl = gsap
                    .timeline({ reversed: true, paused: true })
                    .to(filterRoles, {
                        height: 'auto',
                        paddingTop: '12px',
                        duration: 0.4,
                        ease: 'power1.inOut',
                    })
                    .from(
                        filterBtns,
                        {
                            autoAlpha: 0,
                            x: 20,
                            duration: 0.2,
                            stagger: 0.08,
                            ease: 'power1.inOut',
                        },
                        '-=0.2'
                    );

                filterRolesToggle.addEventListener('click', () => {
                    toggle(filterRolesToggle, tl);
                });
            }
        }
    );

    const updateFilters = (filter) => {
        selectedFilter = filter;

        foundCards = [];
        searchInput.value = '';

        peopleGrid.classList.remove('no-results');

        filterBtns.forEach((filterBtn) => {
            filterBtn.classList.remove('active');

            if (filterBtn.dataset.filter === filter) {
                filterBtn.classList.add('active');
            }
        });

        gsap.to(peopleCards, {
            opacity: 0,
            overwrite: true,
            onComplete: () => {
                peopleCards.forEach((card) => {
                    card.classList.remove('show');

                    if (selectedFilter === 'all') {
                        foundCards.push(card);
                    } else if (card.dataset.type.includes(selectedFilter)) {
                        foundCards.push(card);
                    }
                });

                foundCards.forEach((card) => {
                    card.classList.add('show');
                });

                gsap.to(foundCards, {
                    opacity: 1,
                    overwrite: true
                });
            }
        });

        // Get current URL stuff
        const resultsUrl = new URL(window.location.href);
        const resultsUrlParams = resultsUrl.searchParams;

        if (selectedFilter) {
            const newParams = selectedFilter;
            resultsUrlParams.set('filter', newParams);
        }

        const urlString = resultsUrl.toString();
        window.history.pushState({ path: urlString }, '', urlString);

        window.dispatchEvent(new Event('resize'));
        ScrollTrigger.refresh();
    };

    filterBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
            updateFilters(btn.dataset.filter);
        });
    });

    // Initial check for params
    const url = new URL(window.location.href);
    const urlParams = url.searchParams;
    const paramFilter = urlParams.get('filter');

    if (paramFilter && paramFilter !== 'all') {
        updateFilters(paramFilter);
    }

    // Pop state logic
    window.addEventListener('popstate', (event) => {
        const popUrl = new URL(event.target.location.href);
        const popParams = popUrl.searchParams;
        const popFilter = popParams.get('filter');

        if (popFilter) {
            updateFilters(popFilter);
        }
    });

    function escapeHTML(unsafe) {
        return unsafe.replace(
            // eslint-disable-next-line no-control-regex
            /[\u0000-\u002F\u003A-\u0040\u005B-\u0060\u007B-\u00FF]/g,
            () => ''
        );
    }

    const peopleSearch = (event) => {
        let searchResults = false;

        if (foundCards.length === 0) {
            searchCards = peopleCards;
        } else {
            searchCards = foundCards;
        }

        searchCards.forEach((card) => {
            const personName = card.dataset.name;
            card.classList.remove('show');

            if (personName.includes(event.target.value.toLowerCase())) {
                card.classList.add('show');
                searchResults = true;
            }
        });

        if (!searchResults) {
            searchTermText.textContent = escapeHTML(event.target.value);
            peopleGrid.classList.add('no-results');
        } else {
            peopleGrid.classList.remove('no-results');
        }

        window.dispatchEvent(new Event('resize'));
        ScrollTrigger.refresh();
    };

    searchInput.addEventListener('keyup', peopleSearch);
};

export { initPeopleFilter as default };
